package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class AcceptedTerm(
    val version: Int,
    val acceptedAt: String
)
